module.exports = __webpack_public_path__ + "static/media/ESH-Modern-Slavery.5c40acc3.pdf";